module.exports = __webpack_public_path__ + "img/Screenshot.e662668f.webp";